var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMailSent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 338.252,
    height: 274.83,
    viewBox: "0 0 338.252 274.83",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mail_2_",
    "data-name": "mail (2)",
    transform: "translate(0 -48)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7345",
    fill: "#1e88e5",
    d: "M253.689 259.408H21.141A21.118 21.118 0 0 1 0 238.267V69.141A21.118 21.118 0 0 1 21.141 48h232.548a21.118 21.118 0 0 1 21.141 21.141v169.126a21.118 21.118 0 0 1-21.141 21.141z",
    "data-name": "Path 7345"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7346",
    fill: "#2196f3",
    d: "M253.689 302.845H21.141A20.87 20.87 0 0 1 0 281.7a10.546 10.546 0 0 1 4.294-8.522l126.845-95.133a10.641 10.641 0 0 1 12.552 0l126.845 95.133a10.546 10.546 0 0 1 4.294 8.522 20.87 20.87 0 0 1-21.141 21.145z",
    "data-name": "Path 7346",
    transform: "translate(0 -43.437)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7347",
    fill: "#64b5f6",
    d: "M253.689 48H21.141A20.87 20.87 0 0 0 0 69.141a10.546 10.546 0 0 0 4.294 8.522L131.139 172.8a10.641 10.641 0 0 0 12.552 0l126.845-95.137a10.546 10.546 0 0 0 4.294-8.522A20.87 20.87 0 0 0 253.689 48z",
    "data-name": "Path 7347"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7348",
    fill: "#fafafa",
    d: "M337.2 244.218a21.154 21.154 0 0 0-33.825 16.913v21.141H292.8c-34.42 0-64.81 16.913-84.1 42.414l115.812.529c11.627 0 21.8-10.108 21.8-21.735v-52.523z",
    "data-name": "Path 7348",
    transform: "translate(-70.823 -65.146)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7349",
    fill: "#455a64",
    d: "M324.274 272l84.563 63.422-84.563 63.422v-42.281h-21.339a126.891 126.891 0 0 0-89.848 37.195L208 398.845a84.557 84.557 0 0 1 84.563-84.563h31.711z",
    "data-name": "Path 7349",
    transform: "translate(-70.585 -76.015)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailSent);
export default __webpack_public_path__ + "static/media/mail-sent.6fd40270d390b0e8a28da944747f1234.svg";
export { ForwardRef as ReactComponent };